import { Board, Hex, Piece } from "../game/mechanics";
import { CartesianCoordinates } from "./geometry";

export interface Player {
  id: number;
  name: string;
  piecesRoster: Record<pieceKind, number>;
}

export interface PieceWithCoords extends Piece {
  cartesian: CartesianCoordinates;
}

export type pieceKind = "queen" | "ant" | "spider" | "beetle" | "grasshopper";

export enum PieceKind {
  QUEEN = "queen",
  ANT = "ant",
  SPIDER = "spider",
  BEETLE = "beetle",
  GRASSHOPPER = "grasshopper",
}

export const pieceKindValues: pieceKind[] = [
  "queen",
  "ant",
  "spider",
  "beetle",
  "grasshopper",
];

export type actionType = "place" | "move";

export interface Game {
  onlineGameId: string | null;
  localPlayerId: number | null;
  winner: Player | null;
  board: Board;
  players: Player[];
  turnOfPlayer: Player;
  turn: number;
  action: {
    // type: actionType;
    placing: pieceKind | null;
    moving: Piece | null;
    previewingMoveFor: Piece | null;
  };
  movesHistory: string[];
}

export interface Place {
  type: "place";
  hex: Hex;
  justPlaced: pieceKind;
}

export interface Move {
  type: "move";
  to: Hex;
}

export type action = Place | Move;

interface serverActionCore {
  game: string;
  byPlayer: number;
}
export interface PlaceData extends serverActionCore {
  type: "place";
  hex: string;
  kind: string;
}

export interface MoveData extends serverActionCore {
  type: "move";
  playerId: string;
  piece: string;
  to: string;
}

export type actionData = PlaceData | MoveData;

export type serverAction =
  | { type: "place"; pieceKind: pieceKind; owner: Player; hex: Hex }
  | { type: "move"; piece: Piece; to: Hex };

// interface serverPlace extends serverMoveCore {
//   type: "place";
//   hex: string;
//   kind: string;
// }

// interface serverMove extends serverMoveCore {
//   type: "move";
//   playerId: string;
//   piece: string;
//   to: string;
// }

// export type serverMoveData = serverPlace | serverMove;
